/**
 * 2M Beauty — Slider counter guard (fix for "NaN / of -Infinity")
 * ----------------------------------------------------------------
 * Additive & removable: does NOT modify any core theme file.
 *
 * Root cause it guards against: Horizon's SliderComponent (global.js) computes
 *   slidesPerPage = floor(width / offset)  with offset = slide[1].offsetLeft - slide[0].offsetLeft
 * If the layout is stacked/vertical or not measured yet, offset = 0  ->
 *   totalPages = -Infinity and currentPage = NaN, which get written into the
 *   visible counter on homepage carousels and the product media gallery.
 *
 * Behaviour of this guard:
 *  - Horizontal slider + bad values  -> recompute and write the CORRECT numbers.
 *  - Stacked/vertical layout + bad values -> hide the counter (meaningless there).
 *  - Healthy values -> leave everything untouched.
 *  - Re-checks on load, resize, and on any mutation of the counter text.
 */
(function () {
  'use strict';

  var BAD = /NaN|Infinity/;

  function visibleSlides(comp) {
    var all = comp.querySelectorAll('[id^="Slide-"]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].clientWidth > 0) out.push(all[i]);
    }
    return out;
  }

  function fixComponent(comp) {
    var counter = comp.querySelector('.slider-counter');
    var cur = comp.querySelector('.slider-counter--current');
    var tot = comp.querySelector('.slider-counter--total');
    if (!cur || !tot) return;

    var bad = BAD.test(cur.textContent) || BAD.test(tot.textContent);
    var slider = comp.querySelector('[id^="Slider-"]');
    var slides = slider ? visibleSlides(comp) : [];

    // Stacked / vertical / not-laid-out yet: a page counter is meaningless -> hide it.
    if (!slider || slides.length < 2) {
      if (bad && counter) { counter.style.display = 'none'; cur.textContent = ''; tot.textContent = ''; }
      return;
    }

    var offset = slides[1].offsetLeft - slides[0].offsetLeft;
    if (!isFinite(offset) || offset <= 0) {
      if (bad && counter) { counter.style.display = 'none'; cur.textContent = ''; tot.textContent = ''; }
      return;
    }

    // Horizontal slider: un-hide if we previously hid it, and fix bad numbers.
    if (counter && counter.style.display === 'none') counter.style.display = '';
    if (bad) {
      var perView = Math.max(1, Math.floor((slider.clientWidth - slides[0].offsetLeft) / offset));
      var total = Math.max(1, slides.length - perView + 1);
      var current = Math.round(slider.scrollLeft / offset) + 1;
      current = Math.min(total, Math.max(1, current));
      cur.textContent = String(current);
      tot.textContent = String(total);
    }
  }

  function fixAll() {
    var comps = document.querySelectorAll('slider-component');
    for (var i = 0; i < comps.length; i++) fixComponent(comps[i]);
  }

  function watch(comp) {
    var cur = comp.querySelector('.slider-counter--current');
    var tot = comp.querySelector('.slider-counter--total');
    if (!cur || !tot || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () {
      requestAnimationFrame(function () { fixComponent(comp); });
    });
    [cur, tot].forEach(function (el) {
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function boot() {
    fixAll();
    var comps = document.querySelectorAll('slider-component');
    for (var i = 0; i < comps.length; i++) watch(comps[i]);
    // Catch late-rendered sections / hydration timing races.
    setTimeout(fixAll, 800);
    setTimeout(fixAll, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', fixAll);
  window.addEventListener('resize', fixAll);
})();
